import { get as _get } from 'lodash';

import types from '../actionTypes';

const initialState = {
    list: false,
    detail: false,
};

const reducer = (state = initialState, action) => {
    if (_get(action, 'meta.silent')) {
        return state;
    }
    switch (action.type) {
        case types.NEWS_REQUEST: {
            return {
                ...state,
                list: true,
            };
        }
        case types.NEWS_REQUEST_COMPLETED: {
            return {
                ...state,
                list: false,
            };
        }
        case types.NEWS_DETAIL_REQUEST: {
            return {
                ...state,
                detail: true,
            };
        }
        case types.NEWS_DETAIL_REQUEST_COMPLETED: {
            return {
                ...state,
                detail: false,
            };
        }
        case types.DELETE_NEWS_REQUEST: {
            return {
                ...state,
                [action.meta.id]: true,
            };
        }
        case types.DELETE_NEWS_REQUEST_COMPLETED: {
            return {
                ...state,
                [action.meta.id]: false,
            };
        }
        default: {
            return state;
        }
    }
};
export default reducer;
